/* global Sys, Services, Platform, Resources */
Sys.ns("Services");

/**
 * The Game Rules Service.
 *
 * @class Services.GameRules
 * @extends Services.Base
 */
Services.GameRules = {
    constructor: function() {
        var queryData = Resources.readData("queryData"),
            isGameRulesUrlParameterPresentButEmpty;

        Services.GameRules.superclass.constructor.apply(this, arguments);

        this._enabled = true;

        isGameRulesUrlParameterPresentButEmpty = queryData.hasOwnProperty("gameRulesURL") && queryData.gameRulesURL === "";

        // Disable the game rules when the game rules URL parameter is empty
        if (isGameRulesUrlParameterPresentButEmpty) {
            this._enabled = false;
        }

        this._open = false;
        this._content = null;
    },

    /**
     * Changes state of GameRules.
     *
     * @param {string} stateName – Name of state, 'opened' or 'closed'.
     * @returns {void}
     */
    setState: function(stateName) {
        switch (stateName) {
            case "opened":
                this.openPopup();
                break;

            case "closed":
                this.closePopup();
                break;

            default:
                throw new Error("Unsupported GameRules state: " + stateName);
        }
    },

    /**
     * Enables the game rules (if not already enabled).
     *
     * @returns {void}
     */
    enable: function() {
        if (this._enabled) {
            return;
        }

        this._enabled = true;

        this.publish("enabled");
    },

    /**
     * Disables the game rules (if not already disabled).
     *
     * @returns {void}
     */
    disable: function() {
        if (!this._enabled) {
            return;
        }

        this._enabled = false;

        this.publish("disabled");
    },

    /**
     * Opens the game rules window (if not already open).
     *
     * @returns {void}
     */
    openPopup: function() {
        if (this._open) {
            return;
        }

        this._open = true;

        this.publish("opened");
    },

    /**
     * Closes the game rules window (if not already closed).
     *
     * @returns {void}
     */
    closePopup: function() {
        if (!this._open) {
            return;
        }

        this._open = false;

        this.publish("closed");
    },

    /**
     * Sets the game rules content.
     *
     * Only sets the content if external game rules are not used.
     *
     * @param {string} content The game rules content.
     * @returns {void}
     */
    setContent: function(content) {
        if (this.getExternalGameRulesURL() === null) {
            this._content = content;
            this.publish("contentChanged", content);
        }
    },

    /**
     * Gets the game rules content.
     *
     * @returns {string|null} The game rules content or null if it has not been set.
     */
    getContent: function() {
        return this._content;
    },

    /**
     * Checks if the game rules are enabled.
     *
     * @returns {boolean} Whether or not the game rules are enabled.
     */
    isEnabled: function() {
        return this._enabled;
    },

    /**
     * Checks if the game rules are being shown.
     *
     * @returns {boolean} Whether or not the game rules are being shown.
     */
    isOpen: function() {
        return this._open;
    },

    /**
     * Navigates to game rules page.
     *
     * @returns {void}
     */
    goToGameRules: function() {
        var gameRulesURL = this.getGameRulesURL();

        if (Platform.isMobileDevice || Platform.isTabletDevice) {
            window.location.href = gameRulesURL;
        }
        else if (Platform.isDesktopDevice) {
            window.open(gameRulesURL, "gameRules").focus();
        }
    },

    /**
     * Returns URL to game rules HTML file, operators can override it by using gameRulesURL parameter.
     *
     * @returns {string} The URL game rules page.
     */
    getGameRulesURL: function() {
        var config = Resources.readData("config"),
            folderOffset = "../",
            gameRulesPath = config.gameRulesPath,
            language = Resources.readData("language"),
            queryData = Resources.readData("queryData"),
            gameID = queryData.gameId,
            showRtp = queryData.showRtp,
            gameRulesURL = queryData.gameRulesURL,
            templateURL,
            isGameRulesUrlParameterPresentAndNotEmpty;

        isGameRulesUrlParameterPresentAndNotEmpty = typeof gameRulesURL !== "undefined" && gameRulesURL !== "undefined";
        if (isGameRulesUrlParameterPresentAndNotEmpty) {
            // If operator provides own game rules URL, use it
            return gameRulesURL;
        }

        /* BUILD_START*/
        folderOffset = "../" + folderOffset;

        /* BUILD_END*/

        // remove any seamless wallet indication
        gameID = gameID.replace(/_sw$/, "");

        templateURL = folderOffset + gameRulesPath + "templates/" + gameID + "." + language.lang + ".html";

        if (showRtp === false) {
            templateURL = templateURL.split(language.lang + ".html").join("nortp" + "." + language.lang + ".html");
        }
        return templateURL;
    },

    /**
     * Gets the external game rules URL.
     *
     * @returns {string|null} The external game rules url.
     */
    getExternalGameRulesURL: function() {
        var gameRulesURL,
            queryData,
            isGameRulesUrlParameterPresent;

        queryData = Resources.readData("queryData");
        gameRulesURL = queryData.gameRulesURL;

        isGameRulesUrlParameterPresent = typeof gameRulesURL !== "undefined" && gameRulesURL !== "undefined";
        return isGameRulesUrlParameterPresent ? gameRulesURL : null;
    }
};

Services.GameRules = Sys.extend(
    Services.Base,
    Services.GameRules,
    "Services.GameRules"
);
